import {
  Box,
  Stack,
  Text,
  Pagination,
  Paper,
  Center,
  Loader,
  Flex,
  createStyles,
} from "@mantine/core";
import { DashboardInfo } from "./DashboardInfo";
import LAst7aysButton from "../../assets/img/Button.svg";
import doctors from "../../assets/img/doctors.svg";
import totalDoctor from "../../assets/img/totalDoctor.svg";
import appointmentScheduled from "../../assets/img/appointmentScheduled.svg";
import totalPatient from "../../assets/img/totalPatient.svg";
import { DashboardCommonLayout } from "./DashboardCommonLayout";
import plus from "../../assets/img/plus.svg";
import { MEdicationCard } from "./MedicationCard";
import { useEffect, useState } from "react";
import GenderChart from "./GenderCharts";
import { CustomTable } from "../../components/Table";
import { ClinicalNotescards } from "./ClinicalNotescards";
import Analytics from "./Analytics";
import { PaginationPrevious } from "@mantine/core/lib/Pagination/PaginationEdges/PaginationEdges";
import { useMedplum } from "@medplum/react";
import { useNavigate } from "react-router-dom";
import { MedicationList } from "../Medication/MedicationList";
import { Appointment } from "../Patient/PatientDetails/Appointments";
import { formatDate, formatDateTime } from "@medplum/core";
import { IconChevronRight } from "@tabler/icons-react";
import EEpic from "../../assets/img/EpicPatint.svg";
import cerner from "../../assets/img/CernerPatient.svg";
import aaathena from "../../assets/img/AthenaPatient.svg";
import ecwico from "../../assets/img/ecwpatient.svg";
import nextgenico from "../../assets/img/nextgenico.svg";
import others from "../../assets/img/others.svg";
const useStyles = createStyles(() => ({
  diagonsisText: {
    color: "#1B75BC",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
  },
  thirdBox: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    marginTop: "16px",
    marginBottom: "16px",
    width: "100%",
  },
}));
export const DashboardScreen = () => {
  const { classes } = useStyles();

  const medplum = useMedplum();
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState<any>([]);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [medicationList, setMedicationList] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [reportsList, setReportsList] = useState<any>([]);
  const [appointments, setAppointments] = useState<any>([]);
  const [practinoerList, setPractinoerList] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalAppointments, setTotalAppointments] = useState<any>(0);
  const [chartData, setchartdata] = useState<any>([]);

  const [total, setTotal] = useState<any>("");

  useEffect(() => {
    getPatientList();
    getPractitionerList();
  }, []);

  useEffect(() => {
    setIsFetching(true);
    setMedicationList([]);
    getMedications(selectedPatient);
  }, [selectedPatient]);

  const getMedications = async (id: any) => {
    const medications = await medplum.searchResources("MedicationRequest");
    setMedicationList(medications);
    setIsFetching(false);
  };

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if ((res?.use === "official" || res?.use === "usual") && name === "--") {
          name = res?.text || res?.given[0];
        }
      });
      if (name === "--") name = patientData[0]?.text || patientData[0]?.given
    }
    return name;
  }

  let epic = 0;
  let cernerr = 0;
  let athena = 0;
  let ecw = 0;
  let nextgen = 0;
  let extra = 0;

  const getPatientList = async () => {
    const res = await medplum.searchResources(
      "Patient",
      "_count=500&_offset=0&_sort=-_lastUpdated&_total=accurate"
    );
    const patientData = res.map((patient) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding?.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item?.system && item?.system.includes("athena")
      );
      const containsEcw = patient?.identifier?.some(
        (item) => item?.system && item?.system.includes("ecw")
      );
      const containsNextGen = patient?.identifier?.some(
        (item) => item?.system && item?.system.includes("nextgen")
      );
      let ehrtype = "";

      if (patient?.identifier?.[0]?.type?.text === "EPIC") {
        epic++;
        ehrtype = "EPIC";
      } else if (containsCerner) {
        cernerr++;
        ehrtype = "Cerner";
      } else if (containsAthena) {
        athena++;
        ehrtype = "Athena Health";
      } else if (containsEcw) {
        ecw++;
        ehrtype = "ECW";
      } else if (containsNextGen) {
        nextgen++;
        ehrtype = "nextgen";
      } else {
        extra++;
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img src={EEpic} style={{ marginRight: "10px" }} alt="EPIC" />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img src={cerner} style={{ marginRight: "10px" }} alt="Cerner" />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img src={aaathena} style={{ marginRight: "10px" }} alt="Athena" />
          );
          break;
        case "ECW":
          EHRIcon = (
            <img src={ecwico} style={{ marginRight: "10px" }} alt="ECW" />
          );
          break;
        case "nextgen":
          EHRIcon = (
            <img src={nextgenico} style={{ marginRight: "10px" }} alt="nextgen" />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={others}
              style={{ marginRight: "10px", width: "20px", height: "40px" }}
              alt="NA"
            />
          );
      }
      const gender = patient?.gender ?? "";
      const formattedGender =
        gender?.charAt(0).toUpperCase() + gender?.slice(1).toLowerCase();

      return {
        label: getPatientName(patient?.name),
        // value: patient.id,
        gender: formattedGender,
        dob: patient?.birthDate,
        ehrtype: [EHRIcon, ehrtype],
      };
    });
    let chartDataa = [epic, cernerr, athena, ecw, extra];

    setchartdata(chartDataa);
    // setSelectedPatient(patientData[0].value);
    setPatientList(patientData);
  };

  const mappedList = medicationList.map((med: any) => { });
  let maleCount = 0;
  let femaleCount = 0;
  function calculateAge(dob: string): number {
    const today: Date = new Date();
    const birthDate: Date = new Date(dob);
    let age: number = today.getFullYear() - birthDate.getFullYear();
    const monthDiff: number = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  const countAbove60: number = patientList.reduce((count: number, obj: any) => {
    return calculateAge(obj.dob) > 60 ? count + 1 : count;
  }, 0);

  const patientabove60 = countAbove60;

  patientList.map((patient: any) => {
    if (patient?.gender === "Male") {
      maleCount++;
    } else if (patient?.gender === "Female") {
      femaleCount++;
    }
  });

  const getSelectedPaitentName = (id: string) => {
    let res = patientList.filter((patient: any) => {
      return patient?.value === id;
    });
    return res[0]?.label;
  };
  const getPractitionerList = async () => {
    const res = await medplum.searchResources("Practitioner", "_count=50");
    const practionerData = res.map((patient) => {
      return { label: getPatientName(patient?.name), value: patient?.id };
    });

    setPractinoerList(practionerData);
  };

  // appointments
  useEffect(() => {
    getAppointments();
  }, [currentPage]);


  const getAppointments = async () => {
    try {
      const count = 5;
      const res = await medplum.searchResources(
        "Appointment",
        `_count=${count}&_offset=${(currentPage - 1) * count
        }&_sort=-_lastUpdated&_total=accurate`
      );
      const tt = Math.ceil((res.bundle.total as any) / 5);

      setTotal(tt);
      setTotalAppointments(res.bundle.total);

      if (res?.length) {
        const appointmentData = res?.map((appointment) => ({
          "Appointment Type":
            appointment?.appointmentType?.coding?.[0]?.display,
          Type: appointment?.serviceType?.[0]?.coding?.[0]?.display,
          Date: formatDateTime(appointment?.created as string),
          Status: appointment?.status,
          // Call: "Start Call",
        }));
        setAppointments(appointmentData);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  // diganosis
  const getReports = async (id: any) => {
    const reports = await medplum.searchResources("DiagnosticReport");
    setReportsList(reports);
    setIsFetching(false);
  };
  useEffect(() => {
    setIsFetching(true);
    setReportsList([]);
    getReports(selectedPatient);
  }, [selectedPatient]);

  const last7DaysData = [6, 20, 30, 25, 40, 35, 50];
  const [showAll, setShowAll] = useState(false);
  const dashboardInfoData = [
    {
      Heading: "Finalized Tasks",
      subData: 100,
      growthInPercent: 5,
      src1: totalDoctor,
      last7DaysData: last7DaysData,
    },
    {
      Heading: "Total Doctors",
      subData: practinoerList.length,
      growthInPercent: 10,
      src1: totalDoctor,
      last7DaysData: last7DaysData,
    },
    {
      Heading: "Appointment Scheduled",
      subData: totalAppointments,
      growthInPercent: 10,
      src1: appointmentScheduled,
      last7DaysData: last7DaysData,
    },
    {
      Heading: "Total Patient",
      subData: patientList.length,
      growthInPercent: 10,
      src1: totalPatient,
      last7DaysData: last7DaysData,
    },
  ];
  const medicationData = [
    { heading: "Amoxicillin 500mg", subHeading: "Alice Smith" },
    { heading: "Ibuprofen 200mg", subHeading: "Bob Johnson" },
    { heading: "Loratadine 10mg", subHeading: "Charlie Brown" },
    { heading: "Loratadine 10mg", subHeading: "Charlie Brown" },
    { heading: "Loratadine 10mg", subHeading: "Charlie Brown" },
    { heading: "Loratadine 10mg", subHeading: "Charlie Brown" },
  ];
  const handleClickShowAllmediactaion = () => {
    navigate("/admin/medications");
  };
  const handleClickShowAlldiagonsis = () => {
    navigate("/admin/diagnosticreport");
  };

  const clinicalNotesData = [
    {
      heading: "First Note",
      subHeading: "Subheading 1",
      dateDetail: "12/12/2022",
      details: "This is the first note.",
    },
    {
      heading: "Second Note",
      subHeading: "Subheading 2",
      dateDetail: "12/13/2022",
      details: "This is the second note.",
    },
    {
      heading: "Third Note",
      subHeading: "Subheading 3",
      dateDetail: "12/14/2022",
      details: "This is the third note.",
    },
  ];
  const data = [maleCount, femaleCount, patientabove60, 50];
  const labels = [
    "Males",
    "Females",
    "Patient above age 60",
    "Surgery consultation",
  ];
  const colors = ["#F12222", "#FF9F43", "#00A651", "#1B75Bc"];

  return (
    <Box
      sx={{
        padding: "16px 40px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          height: "36px",
          marginBottom: "16px",
        }}
      >
        <Box>
          <Text
            sx={{
              fontWeight: 700,
              fontSize: "26px",
              lineHeight: "36px",
              color: "#262930",
            }}
          >
            Overview
          </Text>
        </Box>
        <Box sx={{ width: "127px", height: "32px" }}>
          <Box sx={{ width: "100%" }}>
            <img src={LAst7aysButton} />
          </Box>
        </Box>
      </Box>

      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          gridTemplateColumns: "repeat(auto-fit, minmax(450px, 1fr))",
        }}
      >
        {" "}
        {dashboardInfoData.map((data, index) => (
          <DashboardInfo
            key={index}
            Heading={data.Heading}
            subData={data.subData}
            growthInPercent={data.growthInPercent}
            src1={data.src1}
            last7DaysData={data.last7DaysData}
          />
        ))}
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          marginTop: "16px",
          marginBottom: "16px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "66.5%",
            backgroundColor: "white",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <DashboardCommonLayout
            componentName="Patients by EHR Type"
            children={<Box></Box>}
          />
          <GenderChart data={chartData} />
        </Box>

        <Box
          sx={{
            backgroundColor: "white",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <DashboardCommonLayout
            componentName="Medications"
            children={
              <Box>
                <img src={plus} />
              </Box>
            }
          />
          {/* {medicationList
            .slice(0, showAll ? medicationList.length : 4)
            .map((med: any) => (
              <MEdicationCard
                // Add a unique key for each element in the mapped array
                heading={med?.medicationReference?.display}
                subHeading={med.requester?.display}
              />
            ))} */}
          <Paper>
            {/* <Select
              label="Select patient"
              placeholder="Select patient"
              required={true}
              data={patientList}
              mt="lg"
              size="lg"
              radius="md"
              value={selectedPatient}
              onChange={(val) => {
                setSelectedPatient(val);
              }}
              sx={{
                ".mantine-Select-itemsWrapper": {
                  paddingRight: "10px",
                },
              }}
            /> */}
            {medicationList
              .slice(0, showAll ? medicationList.length : 4)
              .map((med: any) => (
                <Flex
                  justify={"space-between"}
                  align={"center"}
                  pt={"16px"}
                  pb={"16px"}
                  pl={"10px"}
                  pr={"10px"}
                  bg={"rgba(241, 249, 255, 1)"}
                  mt="md"
                  mb="md"
                  sx={{
                    borderRadius: "4px",
                    cursor: "pointer",
                    minWidth: "363px",
                    maxWidth: "363px",
                    gap: "8px",
                  }}
                  onClick={() =>
                    navigate(
                      `/admin/medications/${med.id
                      }?name=${getSelectedPaitentName(selectedPatient)}`
                    )
                  }
                >
                  <div style={{ minHeight: "84px", }}>
                    <Text weight={500} mb={4}>
                      {med?.medicationReference?.display.toUpperCase()}
                    </Text>
                    <Text c="gray.6">{med.requester?.display}</Text>
                  </div>
                  <IconChevronRight />
                </Flex>
              ))}
            {medicationList?.length === 0 && !isFetching && (
              <Center style={{ width: "100%", height: "200px" }}>
                <Text size="xl" color="dimmed">
                  No results
                </Text>
              </Center>
            )}
            {isFetching && (
              <Center style={{ width: "100%", height: "200px" }}>
                <Loader />
              </Center>
            )}
          </Paper>

          <Box mt={40}>
            <Text
              sx={{
                color: "#1B75BC",
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "24px",
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={handleClickShowAllmediactaion}
            >
              show all
            </Text>
          </Box>
        </Box>
      </Box>
      {/* second box */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          marginTop: "16px",
          marginBottom: "16px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "75%",
            height: "508px",
            backgroundColor: "white",
            padding: "12px",
            borderRadius: "8px",
            gap: "16px",
          }}
        >
          <Box>
            <DashboardCommonLayout
              componentName="Appointments"
              children={<Box></Box>}
            />
          </Box>
          <Box>
            <CustomTable
              showActionColumn={true}
              head={["Appointment Type", "Type", "Date", "Status"]}
              data={appointments.slice(0, 5)}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            <Pagination
              total={total}
              onChange={handlePageChange}
              defaultValue={currentPage}
            />
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "white",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <DashboardCommonLayout
            componentName="Clinical Notes"
            children={
              <Box>
                <img src={plus} />
              </Box>
            }
          />
          {clinicalNotesData
            .slice(0, showAll ? medicationData.length : 4)
            .map((note, index) => (
              <ClinicalNotescards
                key={index}
                heading={note.heading}
                subHeading={note.subHeading}
                dateDetail={note.dateDetail}
                Details={note.details}
              />
            ))}
          <Box>
            {clinicalNotesData.length > 3 && !showAll && (
              <Text
                sx={{
                  color: "#1B75BC",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={handleClickShowAllmediactaion}
              >
                <Box>Show all</Box>
              </Text>
            )}
          </Box>
        </Box>
      </Box>
      {/* thirdbox */}
      <Box className={classes.thirdBox}>
        <Box
          sx={{
            width: "75%",
            backgroundColor: "white",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <DashboardCommonLayout
            componentName="Recent Patients"
            children={
              <Box>
                <img src={LAst7aysButton} />
              </Box>
            }
          />
          <CustomTable
            showActionColumn={false}
            head={["Patient Name", "Gender", "Birth Date", "EHR Type"]}
            data={patientList.slice(0, 8)}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            {/* <Pagination total={5} />{" "} */}
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              marginBottom: "16px",
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <Analytics
              data={data}
              labels={labels}
              colors={colors}
              d1={patientabove60}
              d2={femaleCount}
              d3={maleCount}
              d4={50}
            />
          </Box>

          <Box
            sx={{
              backgroundColor: "white",
              padding: "12px",
              borderRadius: "8px",
            }}
          >
            <DashboardCommonLayout
              componentName="Diagnostic Reports"
              children={
                <Box>
                  <img src={plus} />
                </Box>
              }
            />
            {/* <Select
              label="Select patient"
              placeholder="Select patient"
              required={true}
              data={patientList}
              mt="lg"
              size="lg"
              radius="md"
              value={selectedPatient}
              onChange={(val) => {
                setSelectedPatient(val);
              }}
              sx={{
                ".mantine-Select-itemsWrapper": {
                  paddingRight: "10px",
                },
              }}
            /> */}
            {/* <Title size="18px" mt="lg" weight={700}>
              Diagnostic Reports List
            </Title> */}
            {reportsList
              .slice(0, showAll ? medicationData.length : 3)
              .map((report: any) => (
                <Flex
                  justify={"space-between"}
                  align={"center"}
                  pt={"16px"}
                  pb={"16px"}
                  pl={"10px"}
                  pr={"10px"}
                  bg={"rgba(241, 249, 255, 1)"}
                  mt="md"
                  mb="md"
                  sx={{
                    borderRadius: "4px",
                    cursor: "pointer",
                    minWidth: "341px",
                    gap: "8px",
                  }}
                  onClick={() =>
                    navigate(
                      `/admin/diagnosticreport/${report.id
                      }?name=${getSelectedPaitentName(selectedPatient)}`
                    )
                  }
                >
                  <div>
                    <Text weight={500} mb={4}>
                      {report.code?.text}
                    </Text>
                    <Text c="gray.6">
                      {formatDate(report.meta?.lastUpdated as string)}
                    </Text>
                  </div>
                  <IconChevronRight />
                </Flex>
              ))}
            {reportsList?.length === 0 && !isFetching && (
              <Center style={{ width: "100%", height: "200px" }}>
                <Text size="xl" color="dimmed">
                  No results
                </Text>
              </Center>
            )}
            {isFetching && (
              <Center style={{ width: "100%", height: "200px" }}>
                <Loader />
              </Center>
            )}
            <Box>
              <Text
                className={classes.diagonsisText}
                onClick={handleClickShowAlldiagonsis}
              >
                show all
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* last */}
    </Box>
  );
};
